import { formatRiskDecimal, getAppropriateRiskLimiter } from './';

export function formatRelativeRiskDecimal(impact: number | string | undefined, cancerType?: string): string {
  if (typeof impact !== 'string' && typeof impact !== 'number') return formatRiskDecimal(impact, cancerType);

  const limiter = getAppropriateRiskLimiter(cancerType);
  const limitedImpact = limiter(impact);

  if (typeof limitedImpact === 'string' && isNaN(Number(limitedImpact))) return limitedImpact;

  const value = typeof limitedImpact === 'string' ? Number(limitedImpact) : limitedImpact;
  const multipliedValue = value * 100;

  return formatRiskDecimal(multipliedValue, cancerType);
}
